//GENERATE_CONTRACT
import axios from 'axios'
import {GENERATE_CONTRACT} from '../../../app/routes'

 export async function generatePDF(obj:any) {
  return await axios.post(GENERATE_CONTRACT, obj)
}